var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"skeletonShimmer"},[(_vm.hasProvidedSlot && this.getTemplateName)?[_c(_vm.getTemplateName,{tag:"component"},[_vm._t("default")],2)]:(_vm.hasProvidedSlot)?[_vm._t("customTemplate")]:(this.getTemplateName)?[_c(_vm.getTemplateName,{tag:"component"},[_vm._t("default")],2)]:[_c('SkeletonDefault',[_vm._t("default")],2)]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }